class Navigation {
  constructor(element, config) {
    this.element = element;
    this.popupSelector = config?.popupSelector || '.js-popup';

    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
    this.selectNext = this.selectNext.bind(this);
    this.selectPrevious = this.selectPrevious.bind(this);
    this.levelUp = this.levelUp.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.element.addEventListener('keydown', (event) => this.onKeyDown(event));
  }

  openPopup(listItem) {
    const popup = listItem.querySelector(this.popupSelector);
    popup.hidden = false;
    listItem.ariaExpanded = 'true';
    setTimeout(() => {
      popup.ariaHidden = 'false';
    }, 10);
  }

  closePopup(listItem) {
    const popup = listItem.querySelector(this.popupSelector);
    popup.ariaHidden = 'true';
    listItem.ariaExpanded = 'false';
    if (popup.dataset.transition === 'true') {
      popup.addEventListener('transitionend', () => {
        if (listItem.ariaExpanded === 'false') {
          popup.hidden = true;
        }
      }, { once: true });
    } else {
      popup.hidden = true;
    }
  }

  togglePopup(listItem) {
    if (listItem.ariaExpanded === 'false') {
      this.openPopup(listItem);
    } else {
      this.closePopup(listItem);
    }
  }

  static getFocusable(element) {
    return element.querySelectorAll('a, button');
  }

  static selectFirst(listItem) {
    const focusable = Navigation.getFocusable(listItem.closest('ul').firstElementChild);
    focusable[0].focus();
  }

  static selectLast(listItem) {
    const focusable = Navigation.getFocusable(listItem.closest('ul').lastElementChild);
    focusable[focusable.length - 1].focus();
  }

  selectNext(listItem) {
    if (listItem.ariaHasPopup) this.closePopup(listItem);
    if (listItem.nextElementSibling) {
      const focusable = Navigation.getFocusable(listItem.nextElementSibling);
      focusable[0].focus();
    } else {
      Navigation.selectFirst(listItem);
    }
  }

  selectPrevious(listItem) {
    if (listItem.ariaHasPopup) this.closePopup(listItem);
    if (listItem.previousElementSibling) {
      const focusable = Navigation.getFocusable(listItem.previousElementSibling);
      focusable[0].focus();
    } else {
      Navigation.selectLast(listItem);
    }
  }

  levelUp(listItem) {
    const upperLevelItem = listItem.closest('ul').closest('li');
    if (upperLevelItem) {
      const focusable = Navigation.getFocusable(upperLevelItem);
      focusable[0].focus();
      if (upperLevelItem.ariaHasPopup && upperLevelItem.ariaExpanded) {
        this.closePopup(upperLevelItem);
      }
    } else if (listItem.ariaHasPopup && listItem.ariaExpanded === 'true') {
      this.closePopup(listItem);
    }
  }

  static levelDown(listItem) {
    const focusable = Navigation.getFocusable(listItem.querySelector('ul'));
    focusable[0].focus();
  }

  onKeyDown(event) {
    const { code } = event;
    const listItem = document.activeElement.closest('li');

    switch (code) {
      case 'Space':
        event.preventDefault();
        if (listItem.ariaHasPopup === 'true') {
          this.togglePopup(listItem);
        }
        break;
      case 'Enter':
        if (listItem.ariaHasPopup === 'true') {
          event.preventDefault();
          this.togglePopup(listItem);
        }
        break;
      case 'ArrowUp':
        event.preventDefault();
        if (listItem.previousElementSibling) {
          this.selectPrevious(listItem);
        } else {
          this.levelUp(listItem);
        }
        break;
      case 'ArrowRight':
        this.selectNext(listItem);
        break;
      case 'ArrowDown':
        event.preventDefault();
        if (listItem.ariaHasPopup && listItem.ariaExpanded === 'false') {
          this.openPopup(listItem);
        } else if (listItem.ariaHasPopup && listItem.ariaExpanded === 'true') {
          Navigation.levelDown(listItem);
        } else if (listItem.querySelector('ul')) {
          Navigation.levelDown(listItem);
        } else {
          this.selectNext(listItem);
        }
        break;
      case 'ArrowLeft':
        this.selectPrevious(listItem);
        break;
      case 'Home':
        event.preventDefault();
        Navigation.selectFirst(listItem);
        break;
      case 'End':
        event.preventDefault();
        Navigation.selectLast(listItem);
        break;
      case 'Escape':
        this.levelUp(listItem);
        break;
      default:
        break;
    }
  }
}

export default Navigation;
